<template>
  <div class="onboarding-container">
    <!-- Верхний блок -->
    <div class="header">
      <button v-if="currentStep > 0" class="back-button" @click="prevStep">
        <i class="pi pi-chevron-left"></i>
      </button>
      <div class="title-container">
        <h2 class="title">{{ steps[currentStep].title }}</h2>
        <p class="description">{{ steps[currentStep].description }}</p>
      </div>
    </div>

    <!-- Центральный блок -->
    <div class="content">
      <component :is="steps[currentStep].component" />
    </div>

    <!-- Кнопка "Далее" -->
    <div class="footer pt-4">
      <button class="next-button" @click="nextStep">
        {{ currentStep === steps.length - 1 ? "Готово" : "Далее" }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import Step1 from "./steps/Step1.vue";
import Step2 from "./steps/Step2.vue";
import Step3 from "./steps/Step3.vue";
import Step4 from "./steps/Step4.vue";

export default defineComponent({
  name: "OnboardingView",
  setup() {
    // Текущий шаг
    const currentStep = ref(0);

    // Данные шагов
    const steps = [
      {
        title: "Добро пожаловать",
        description:
          "Узнайте ваш сердечно-сосудистый риск и получите персонализированные рекомендации!",
        component: Step1,
      },
      {
        title: "Настройка профиля",
        description: "Заполните ваш профиль, чтобы начать.",
        component: Step2,
      },
      {
        title: "Настройка профиля",
        description: "Заполните ваш профиль, чтобы начать.",
        component: Step3,
      },
      {
        title: "Настройка профиля",
        description: "Заполните ваш профиль, чтобы начать.",
        component: Step4,
      },
      {
        title: "Уведомления",
        description: "Настройте уведомления, чтобы быть в курсе.",
        component: "StepNotifications",
      },
      {
        title: "Советы и рекомендации",
        description: "Получайте персонализированные рекомендации.",
        component: "StepTips",
      },
      {
        title: "Готово",
        description: "Теперь вы можете использовать приложение!",
        component: "StepFinish",
      },
    ];

    const nextStep = () => {
      if (currentStep.value < steps.length - 1) {
        currentStep.value++;
      }
    };

    const prevStep = () => {
      if (currentStep.value > 0) {
        currentStep.value--;
      }
    };

    const finishOnboarding = () => {
      console.log("Онбординг завершен");
      // Здесь можно перенаправить на главную страницу или другое действие
    };

    return { currentStep, steps, nextStep, prevStep, finishOnboarding };
  },
});
</script>

<style scoped>
/* Контейнер всей страницы */
.onboarding-container {
  display: flex;
  justify-content: space-between;
  height: 100vh;
  background-color: #f8f9fa;
  padding: 16px;
  box-sizing: border-box;
  flex-direction: column;
}

/* Верхний блок */
.header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0px;
  position: relative;
}

.back-button {
  position: absolute;
  left: 0;
  top: 0;
  background: transparent;
  border: none;
  font-size: 24px;
  color: #4caf50;
  cursor: pointer;
}

.title-container {
  text-align: center;
}

.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
}

.description {
  font-size: 14px;
  color: #666;
}

/* Центральный блок */
.content {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  min-height: fit-content;
}

/* Нижний блок */
.footer {
  width: 100%;
  display: flex;
  justify-content: center;
}

.next-button {
  width: 90%;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
}

.next-button:hover {
  background-color: #45a049;
}
</style>
